const headerLinks = [
  {
    key: "overview",
    link: "/",
    label: "Overview",
  },
  {
    key: "keynote",
    link: "/keynote",
    label: "Keynote Speaker",
  },
  {
    key: "thread1",
    link: "/thread-1",
    label: "Thread 1",
  },
  {
    key: "thread2",
    link: "/thread-2",
    label: "Thread 2",
  },
  {
    key: "poster",
    link: "/poster-gallery",
    label: "Poster Gallery",
  },
  {
    key: "team",
    link: "/team",
    label: "The Team",
  },
];

export default headerLinks;
